import { render, staticRenderFns } from "./TaskStatusTracker.vue?vue&type=template&id=45e7b4f8&"
import script from "./TaskStatusTracker.vue?vue&type=script&lang=js&"
export * from "./TaskStatusTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports